import {Routes} from '@angular/router';
import {UserGuard} from './guards/user/user-guard';
import {PaymentNoticeGuard} from './guards/payment-notice/payment-notice.guard';
import {unsavedChangesGuard} from './components/dynamic-form';
import {NoAuthGuard} from './guards/user/no-auth.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full'
  },
  // Public routes
  {
    path: 'login',
    loadComponent: () => import('./pages/login/login').then(m => m.Login),
    canActivate: [NoAuthGuard],
  },
  {
    path: 'recovery-psw',
    loadComponent: () => import('./pages/recovery-psw/recovery-psw').then(m => m.RecoveryPsw),
  },

  // Protected routes
  {
    path: 'home',
    loadComponent: () => import('./pages/home/home').then(m => m.Home),
    canActivate: [UserGuard, PaymentNoticeGuard],
  },
  {
    path: 'liquidazioni-iva',
    loadComponent: () => import('./pages/liquidazioni-iva/liquidazioni-iva').then(m => m.LiquidazioniIva),
    canActivate: [UserGuard, PaymentNoticeGuard],
  },
  {
    path: 'bollo-fatture',
    loadComponent: () => import('./pages/bollo-fatture/bollo-fatture').then(m => m.BolloFatture),
    canActivate: [UserGuard, PaymentNoticeGuard],
  },
  {
    path: 'ritenute-acconto',
    loadComponent: () => import('./pages/ritenute-acconto/ritenute-acconto').then(m => m.RitenuteAcconto),
    canActivate: [UserGuard, PaymentNoticeGuard],
  },
  {
    path: 'reverse-charge',
    loadComponent: () => import('./pages/reverse-charge/reverse-charge').then(m => m.ReverseCharge),
    canActivate: [UserGuard, PaymentNoticeGuard],
  },

  // Clienti
  {
    path: 'clienti/anagrafiche',
    loadComponent: () => import('./pages/clienti-anagrafiche/clienti-anagrafiche').then(m => m.ClientiAnagrafiche),
    canActivate: [UserGuard, PaymentNoticeGuard],
  },
  {
    path: 'clienti/categorie',
    loadComponent: () => import('./pages/clienti-categorie/clienti-categorie').then(m => m.ClientiCategorie),
    canActivate: [UserGuard, PaymentNoticeGuard],
  },

  // Gestione Studio
  {
    path: 'studio/anagrafica',
    loadComponent: () => import('./pages/studio-anagrafica/studio-anagrafica').then(m => m.StudioAnagrafica),
    canActivate: [UserGuard, PaymentNoticeGuard],
    canDeactivate: [unsavedChangesGuard],
  },
  {
    path: 'studio/utenti',
    loadComponent: () => import('./pages/studio-utenti/studio-utenti').then(m => m.StudioUtenti),
    canActivate: [UserGuard, PaymentNoticeGuard],
  },
  {
    path: 'studio/configurazione',
    loadComponent: () => import('./pages/studio-configurazione/studio-configurazione').then(m => m.StudioConfigurazione),
    canActivate: [UserGuard, PaymentNoticeGuard],
  },
  {
    path: 'studio/backup-archivi',
    loadComponent: () => import('./pages/studio-backup-archivi/studio-backup-archivi').then(m => m.StudioBackupArchivi),
    canActivate: [UserGuard, PaymentNoticeGuard],
  },
  {
    path: 'studio/licenza/contratto',
    loadComponent: () => import('./pages/studio-licenza-contratto/studio-licenza-contratto').then(m => m.StudioLicenzaContratto),
    canActivate: [UserGuard, PaymentNoticeGuard],
  },
  {
    path: 'studio/licenza/canone',
    loadComponent: () => import('./pages/studio-licenza-canone/studio-licenza-canone').then(m => m.StudioLicenzaCanone),
    canActivate: [UserGuard, PaymentNoticeGuard],
  },

  // Gestione Moduli - Elaborare
  {
    path: 'moduli/elaborare',
    loadComponent: () => import('./pages/moduli-elaborare/moduli-elaborare').then(m => m.ModuliElaborare),
    canActivate: [UserGuard, PaymentNoticeGuard],
  },
  {
    path: 'moduli/elaborare/conti',
    loadComponent: () => import('./pages/moduli-elaborare-conti/moduli-elaborare-conti').then(m => m.ModuliElaborareConti),
    canActivate: [UserGuard, PaymentNoticeGuard],
  },
  {
    path: 'moduli/elaborare/credenziali-ade',
    loadComponent: () => import('./pages/moduli-elaborare-credenziali-ade/moduli-elaborare-credenziali-ade').then(m => m.ModuliElaborareCredenzialiAde),
    canActivate: [UserGuard, PaymentNoticeGuard],
    canDeactivate: [unsavedChangesGuard],
  },
  {
    path: 'moduli/elaborare/gestionale-studio',
    loadComponent: () => import('./pages/moduli-elaborare-gestionale-studio/moduli-elaborare-gestionale-studio').then(m => m.ModuliElaborareGestionaleStudio),
    canActivate: [UserGuard, PaymentNoticeGuard],
  },

  // Gestione Moduli - Condividere
  {
    path: 'moduli/condividere',
    loadComponent: () => import('./pages/moduli-condividere/moduli-condividere').then(m => m.ModuliCondividere),
    canActivate: [UserGuard, PaymentNoticeGuard],
  },
  {
    path: 'moduli/condividere/conti',
    loadComponent: () => import('./pages/moduli-condividere-conti/moduli-condividere-conti').then(m => m.ModuliCondividereConti),
    canActivate: [UserGuard, PaymentNoticeGuard],
  },
  {
    path: 'moduli/condividere/cartelle',
    loadComponent: () => import('./pages/moduli-condividere-cartelle/moduli-condividere-cartelle').then(m => m.ModuliCondividereCartelle),
    canActivate: [UserGuard, PaymentNoticeGuard],
  },
  {
    path: 'moduli/condividere/documenti',
    loadComponent: () => import('./pages/moduli-condividere-documenti/moduli-condividere-documenti').then(m => m.ModuliCondividereDocumenti),
    canActivate: [UserGuard, PaymentNoticeGuard],
  },

  // Gestione Moduli - Comunicare
  {
    path: 'moduli/comunicare',
    loadComponent: () => import('./pages/moduli-comunicare/moduli-comunicare').then(m => m.ModuliComunicare),
    canActivate: [UserGuard, PaymentNoticeGuard],
  },
  {
    path: 'moduli/comunicare/conti',
    loadComponent: () => import('./pages/moduli-comunicare-conti/moduli-comunicare-conti').then(m => m.ModuliComunicareConti),
    canActivate: [UserGuard, PaymentNoticeGuard],
  },
  {
    path: 'moduli/comunicare/cartelle',
    loadComponent: () => import('./pages/moduli-comunicare-cartelle/moduli-comunicare-cartelle').then(m => m.ModuliComunicareCartelle),
    canActivate: [UserGuard, PaymentNoticeGuard],
  },
  {
    path: 'moduli/comunicare/documenti',
    loadComponent: () => import('./pages/moduli-comunicare-documenti/moduli-comunicare-documenti').then(m => m.ModuliComunicareDocumenti),
    canActivate: [UserGuard, PaymentNoticeGuard],
  },

  // Assistenza
  {
    path: 'assistenza',
    loadComponent: () => import('./pages/assistenza/assistenza').then(m => m.Assistenza),
    canActivate: [UserGuard, PaymentNoticeGuard],
  },
  {
    path: 'assistenza/ticket',
    loadComponent: () => import('./pages/assistenza-ticket/assistenza-ticket').then(m => m.AssistenzaTicket),
    canActivate: [UserGuard, PaymentNoticeGuard],
  },
  {
    path: 'assistenza/informazioni',
    loadComponent: () => import('./pages/assistenza-informazioni/assistenza-informazioni').then(m => m.AssistenzaInformazioni),
    canActivate: [UserGuard, PaymentNoticeGuard],
  },
  {
    path: 'note-di-rilascio',
    loadComponent: () => import('./pages/release-notes/release-notes.component').then(m => m.ReleaseNotes),
    canActivate: [UserGuard, PaymentNoticeGuard],
  },

  // Redirects
  {
    path: '**',
    redirectTo: 'login',
    pathMatch: 'full'
  },
];
